import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import { hook, withValue } from '@g4/automation-hooks';

import Asterisk from './Asterisk';
import { Text, Box } from './Boneyard';

export const Inline = withTheme(
  ({ children, theme, automationHook, bold = false, size = 14 }) => (
    <Text
      size={size}
      weight={bold ? 500 : 400}
      color={theme.colors.common.textSecondary}
      automationHook={withValue(automationHook, 'label')}
    >
      {children}
    </Text>
  )
);
Inline.displayName = 'Label.Inline';

Inline.propTypes = {
  children: PropTypes.node,
  automationHook: PropTypes.string,
  theme: PropTypes.object,
};

const StyledLabel = styled.label`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Block = withTheme(
  ({
    isRequired = false,
    bold = false,
    children,
    htmlFor,
    theme,
    automationHook,
    size = 12,
  }) => (
    <Box mb={2}>
      <StyledLabel htmlFor={htmlFor}>
        <Text
          size={size}
          weight={500}
          color={theme.colors.common.textSecondary}
          automationHook={withValue(automationHook, 'label')}
        >
          {children}
        </Text>
        {isRequired && <Asterisk {...hook(automationHook, 'required')} />}
      </StyledLabel>
    </Box>
  )
);
Block.displayName = 'Label.Block';

Block.propTypes = {
  children: PropTypes.node,
  htmlFor: PropTypes.string.isRequired,
  automationHook: PropTypes.string,
  isRequired: PropTypes.bool,
  theme: PropTypes.object,
  size: PropTypes.number,
};
